import registerPerformanceObserver from '../register-performance-observer';

const RECORD_TYPE = 'largest-contentful-paint';

/**
 * Observe entries of type `largest-contentful-paint`, including buffered
 * entries, i.e. entries that occurred before calling `observe()`.
 */
const largestContentfulPaintObserver = (
  callback: (largestContentPulPaint: number) => void
) => {
  let lcp: number;

  // Send the latest LCP value to your analytics server once the user
  // leaves the tab.
  const onDisconnect = () => {
    if (lcp) {
      callback(lcp);
    }
  };

  return registerPerformanceObserver(
    RECORD_TYPE,
    entryList => {
      const entries = entryList.getEntries();
      const lastEntry = entries[entries.length - 1];

      // @ts-ignore (for lastEntry.renderTime and lastEntry.loadTime)
      lcp = lastEntry.renderTime || lastEntry.loadTime;
    },
    onDisconnect
  );
};

export default largestContentfulPaintObserver;
